var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonAccepterad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.835,
    height: 13.065,
    viewBox: "0 0 16.835 13.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accepterad",
    transform: "translate(-8126.743 -5853.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36654",
    "data-name": "Path 36654",
    d: "M134.007,65.016,127.581,58.8a.75.75,0,1,1,1.043-1.078l5.274,5.1,8.967-10.606a.75.75,0,0,1,1.145.968Z",
    transform: "translate(7999.391 5801.714)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonAccepterad);
export default __webpack_public_path__ + "static/media/Ikon_Accepterad.1f709dfa3a952d225f46bd7e9001c5c8.svg";
export { ForwardRef as ReactComponent };